import "./index.css";

import { Button } from "../../../components/Shared/Button";

function FillInTheBlankWidget(props) {
  function createInput(idx) {
    return (
      <span className="FillInTheBlankEmployeeReaderWidget">
        <input
          type="text"
          disabled={true}
        />
      </span>
    )
  }

  function renderQuestion() {
    const { question } = props;
    if (question.length === 0) {
      return <></>;
    }

    const html = []
    let i = 0, j = 0, hasFillInTheBlanks = false;
    while (i < question.length) {
      const q = question[i];
      if (i + 2 <= question.length && question[i] === "_" && question[i+1] === "_") {
        hasFillInTheBlanks = true;
        html.push(<span className="questionText">{question.slice(j, i)}</span>);
        html.push(createInput());
        i += 2;
        j = i;
        continue;
      }
      i++;
    }

    if (!hasFillInTheBlanks) {
      html.push(<span className="questionText">{question}</span>)
    }

    html.push(<span className="questionText">{question.slice(j, question.length)}</span>);
    return html;
  }

  return (
    <div className="ReaderWidget FillInTheBlankReaderWidget">
      {/* <div className="FillInTheBlankReaderWidgetHeader">Fill in the blank</div> */}
      {renderQuestion()}
      {/* <div className="FillInTheBlankReaderWidgetSubmit">
        <Button text="Save" />
      </div> */}
    </div>
  )
}

export { FillInTheBlankWidget };
